export class NetworkConstants {
    public static  NETWORK_NAMES = {
        TRANSIT : 'All vCenters',
        COMPUTE : 'Single vCenter',
        DIRECT : 'Direct Connect',
        INTERNET: 'Internet'
    };
    public static NETWORK_VALUES = {
        TRANSIT : 1 ,
        COMPUTE : 2
    };
    public static OPERATION_MODE = {
        'ADD' : 1,
        'EDIT': 2
    };
    public static STATE = {
        'CREATE_IN_PROGRESS' : 'CREATE_IN_PROGRESS',
        'IN_PROGRESS': 'IN_PROGRESS',
        'DELETE_IN_PROGRESS': 'DELETE_IN_PROGRESS',
        'REALIZED': 'REALIZED',
        'NOT_REALIZED': 'NOT_REALIZED',
        'ERROR': 'ERROR'
    }
    public static SYSTEM: String = 'System';
}



// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vc/networks/network-constants.ts